import { integrations } from "@/data/roadmap";
import { ROADMAP } from "@/constants/testIds/roadmap";
import { SectionLabel } from "./ExecSummary";

export default function Integrations() {
  // duplicate list for seamless marquee
  const list = [...integrations, ...integrations];

  return (
    <section
      id="integrations"
      data-testid={ROADMAP.integrationsSection}
      className="py-20 lg:py-28 border-b border-[#DEE2E6] bg-white overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionLabel n="07" label="Integrations" />
        <div className="grid lg:grid-cols-12 gap-6 mt-3 items-end">
          <h2 className="lg:col-span-7 font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter font-bold">
            Plays nicely with the systems you already run.
          </h2>
          <p className="lg:col-span-5 text-[#495057] leading-relaxed">
            Pre-built connectors and an open API. From local Ghanaian banks to global SaaS — your
            ERP doesn&apos;t need to be an island.
          </p>
        </div>
      </div>

      <div className="mt-14 border-y border-[#0A0A0A] bg-[#F8F9FA]">
        <div className="flex marquee">
          {list.map((it, i) => (
            <div
              key={i}
              className="flex-shrink-0 px-8 py-6 border-r border-[#DEE2E6] font-heading text-xl font-medium tracking-tight text-[#0A0A0A]"
            >
              {it}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-10 grid md:grid-cols-3 gap-4 text-xs uppercase tracking-[0.15em] text-[#495057]">
        <div className="border-l-2 border-[#0033A0] pl-4">
          <div className="font-semibold text-[#0A0A0A]">OAuth & SAML</div>
          <div className="mt-1 normal-case tracking-normal text-sm">
            SSO with Google, Microsoft 365, Okta and any SAML 2.0 IdP.
          </div>
        </div>
        <div className="border-l-2 border-[#0B7A75] pl-4">
          <div className="font-semibold text-[#0A0A0A]">Webhooks & REST API</div>
          <div className="mt-1 normal-case tracking-normal text-sm">
            Every entity in Gr8Boost ERP is fully scriptable from your tools.
          </div>
        </div>
        <div className="border-l-2 border-[#FF4F00] pl-4">
          <div className="font-semibold text-[#0A0A0A]">Custom connectors</div>
          <div className="mt-1 normal-case tracking-normal text-sm">
            Integration team builds banking, biometric & IoT feeds on request.
          </div>
        </div>
      </div>
    </section>
  );
}
